<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">

  <div class="content-section">
    <h2>Assurance Objets d'Art - Objets de Valeur - Collection</h2>
    <p>
      L'assurance <strong class="text-purple">Œuvres d'Art – Bijoux, Objet de Valeur, de Collection</strong> offre aux propriétaires d'œuvres d'art une couverture financière contre tous les dangers possibles, du vol simple à la destruction en passant par les dommages de transport.
    </p>
    <p>
      L'assurance œuvre d'art et de collection a été spécialement créée pour garantir les objets d'art et les objets de collection des particuliers et professionnels (galeries, musées, etc). Ce produit apporte une réponse adaptée à la préservation des biens mobiliers de valeur en complément de l'assurance habitation pour les particuliers, et en complément de l'assurance des locaux (Multirisque Professionnelle ou industrielle pour les organismes).
    </p>
    <p>
      Nombreux d'entre vous se posent la question "œuvre d'art et assurance habitation". Sachez que cette assurance Œuvre d'Art, ou assurance objets de valeur, ou assurance bijoux, ou assurance tableaux vient toujours compléter l'assurance Habitation dite <strong class="text-purple">assurance MRH</strong> ou <strong class="text-purple">Assurance Multirisque Habitation</strong>.
    </p>
    <p>
      Le courtier en Assurance BROKINS est partenaire de quelques assureurs, dont un échantillon est listé ci-après : <strong class="text-purple">GENERALI, LIBERTY SPECIALITY, HELVETIA.</strong>
    </p>
  </div>

  <div class="content-section bg-light">
    <h2>A qui s'adresse ce contrat d'assurance Oeuvre d'Art ?</h2>
    <p>Ce produit d'assurance est ouvert à tous les clients, quels qu'ils soient, comme :</p>
    <ul class="target-list">
      <li>Les particuliers et collections privées,</li>
      <li>Les entreprises, les professions libérales, les hôtels,</li>
      <li>Les professionnels de l'art (antiquaires, galeries d'art, marchands de tapis et de tapisseries anciens, marchands de livres et manuscrits anciens et/ou rares, marchands d'armes anciennes, commissaires priseurs, luthiers, fabricants de clavecins et d'autres instruments de musiques fabriqués artisanalement, restaurateurs de tableaux, meubles et objets d'art),</li>
      <li>Les musées, fondations, bibliothèques, archives,</li>
      <li>Les expositions, foires, salons d'art et d'antiquités (y compris exposition de véhicules de collection), en demandant l'assurance œuvre d'art tous risques expositions</li>
      <li>Les véhicules de collection (hors circulation).</li>
    </ul>
  </div>

  <div class="content-section">
    <h2>Familles d'objets concernés par cette assurance ?</h2>
    <ul class="object-families">
      <li>Tableaux et assimilés,</li>
      <li>Mobilier ancien ou design,</li>
      <li>Sculpture,</li>
      <li>Tapis et tapisseries,</li>
      <li>Verrerie et porcelaine,</li>
      <li>Jades, ivoires, articles de Chine,</li>
      <li>Bijoux et montres (à hauteur de <strong class="highlight-purple">25 %</strong> du capital assuré),</li>
      <li>Argenterie / orfèvrerie,</li>
      <li>Fusils de collection,</li>
      <li>Instruments de musique de fabrication ancienne,</li>
      <li>Pianos,</li>
      <li>Livres, manuscrits,</li>
      <li>Timbres (risques réservés),</li>
      <li>Pièces de monnaie (risques réservés),</li>
      <li>Véhicules de collection à l'arrêt.</li>
    </ul>
  </div>

  <div class="content-section bg-accent">
    <h2>Les principales garanties de cette assurance :</h2>
    <p>Il s'agit très souvent d'un contrat tous risques sur mesure assorti de garanties étendues :</p>
    <ul class="guarantees-list">
      <li>Incendie,</li>
      <li>Dégâts des eaux,</li>
      <li>Vol avec effraction, vandalisme,</li>
      <li>Tempête, grêle et neige sur les toitures,</li>
      <li>Catastrophes naturelles,</li>
      <li>Dommages accidentels (exemple : la chute accidentelle d'un tableau),</li>
      <li>Dépréciation après sinistre (évaluée par un expert),</li>
      <li>Elle couvre également les frais de prévention de dommages comme le remplacement de systèmes d'alarme en cas de perte de clé.</li>
    </ul>
    
    <h3>Mais également assorties de services adaptés à la préservation des objets d'art et de valeur :</h3>
    <ul class="exclusions-list">
      <li>Conseil et accompagnement par une équipe de souscription dédiée,</li>
      <li>Aide à l'évaluation des collections par la mise à disposition d'un réseau d'experts,</li>
      <li>En cas de sinistre, assistance <strong class="text-purple">Europ Assistance 24/24h et 7/7j</strong>.</li>
    </ul>
  </div>

  <div class="content-section">
    <h2>Les extensions de garanties possibles :</h2>
    <ul class="extensions-list">
      <li>Bris, casse et détérioration des objets fragiles,</li>
      <li>Transport,</li>
      <li>Œuvres en extérieur,</li>
      <li>Couverture d'assurance contre la détérioration, la destruction et la perte à l'emplacement de l'objet ou durant le transport,</li>
      <li>Prise en charge des frais engagés pour la récupération : frais de voyage, douane, transport et avocats, etc…,</li>
      <li>Prise en charge des frais de diminution du dommage,</li>
      <li>Remboursement des frais de déblaiement et d'extinction d'incendie,</li>
      <li>Couverture d'assurance possible pour plusieurs lieux d'assurance avec libre passage entre les différents lieux.</li>
    </ul>
    <p>
      Par ailleurs, sachez que si vous souhaitez transférer par vos propres moyens vos objets d'art d'un endroit à un autre, il vous sera nécessaire de souscrire à une <strong class="text-purple">Assurance Marchandises Transportées</strong>.
    </p>
  </div>

  <div class="content-section bg-light">
    <h2>Montant maximal qu'il est possible de garantir :</h2>
    <p>De <strong class="highlight-purple">3000€</strong> d'objets de valeur à <strong class="highlight-purple">100 millions d'euros</strong>.</p>
    <p>
      La valeur d'assurance d'objets d'art est déterminée par la valeur du marché au moment du sinistre. Laquelle correspond au prix d'acquisition d'un objet de même nature et qualité.
    </p>
  </div>

  <div class="content-section">
    <h2>Tarif de cette assurance :</h2>
    <p>La prime minimale à payer est de <strong class="highlight-purple">350 €</strong>.</p>
  </div>

  <div class="content-section bg-accent">
    <h2>Ce qui se passe en cas de sinistre :</h2>
    <ul class="claim-process">
      <li><strong>Sinistre partiel :</strong> règlement intégral des frais de restauration, y compris de la dépréciation éventuelle de l'objet dans la limite de la valeur assurée,</li>
      <li><strong>Sinistre total :</strong> règlement intégral dans la limite de la valeur de l'objet assuré.</li>
    </ul>
  </div>
</app-page-layout>
